import Paper from '@mui/material/Paper';

import {  styled } from '@mui/material/styles';

export const Container = styled(Paper)(() => ({
  padding: 16,
  display: 'flex',
  alignItems: 'baseline',
  flexDirection: 'column',
  rowGap: 4,

  '> strong': {
    fontSize: '1.25rem',
  },
}));
